module.exports = __webpack_public_path__ + "static/media/banner-full2.23ee4b66.png";